export var copyToClipboard = function(clip, description) {
    return navigator.clipboard.writeText(clip);
};

//# sourceMappingURL=browser.js.map